module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/changeLogs/Main.ejs -->\n<div class="wrapper wrapper-content companies">\n    <div class="row">\n        <div class="ibox float-e-margins">\n            <div class="ibox-title">\n                ';
 if (company) { 
__p+='\n                    <div class="flex-container-row">\n                        <a href="" class="js-back" title="Return to companies list">\n                            <i class="fa fa-2x fa-arrow-left"></i>\n                        </a>\n                        &nbsp;\n                        <h3>\n                            Logs for company:\n                            '+
((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
'\n                        </h3>\n                    </div>\n                ';
 } 
__p+='\n                <div class="ibox-tools">\n                    <h5>&nbsp;Total logs: '+
((__t=( total ))==null?'':_.escape(__t))+
'</h5>\n                </div>\n            </div>\n            <div class="ibox-content">\n                <table class="footable table table-stripped toggle-arrow-tiny "\n                    data-striping="false">\n                    <thead>\n                        <tr>\n                            <th>Time</th>\n                            <th>Description</th>\n                            <th>Person</th>\n                        </tr>\n                    </thead>\n                    <tbody class="js-logs">\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        '+
((__t=( require('commons/templates/Paginator.ejs')({
            pagination: pagination, items: 'logs'
        }) ))==null?'':__t)+
'\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/changeLogs/Main.ejs
// module id = 668
// module chunks = 1